import { useEffect, useState, useCallback } from "react";
import "./TornaACasa.css";

const T = {
  en:{dot:"Take me home",kicker:"Your pass",title:"Torna<br>a casa",sub:"One tap and you're home. Call a taxi, then show this pass to the driver.",
      from:"From",to:"To",now:"Now",s1:"Call your taxi",trusted:"Trusted by your host",call:"Call",apps:"Or use an app",open:"Open",
      dest:"Destination already set",metro:"Night transport",first:"First",last:"Last",walk:"min walk",
      cta:"Taxi on its way? Tap here",ctaSub:"Show the driver where to take you",
      dKick:"Show to the driver",dTitle:"Mostra al<br>tassista",dSub:"Turn your screen to the driver",
      lbl:"Destination address",phraseT:"Please take me to this address.",maps:"Open in Maps",back:"Back",noAddr:"Your host hasn't added the address yet.",bubble:"Need to get home? Use me — I'll help you all night"},
  it:{dot:"Torna a casa",kicker:"Il tuo pass",title:"Torna<br>a casa",sub:"Un tocco e sei a casa. Chiama un taxi, poi mostra questo pass al tassista.",
      from:"Da",to:"A",now:"Adesso",s1:"Chiama il taxi",trusted:"Di fiducia del tuo host",call:"Chiama",apps:"Oppure usa un'app",open:"Apri",
      dest:"Destinazione già impostata",metro:"Mezzi notturni",first:"Prima",last:"Ultima",walk:"min a piedi",
      cta:"Il taxi sta arrivando? Premi qui",ctaSub:"Mostra al tassista dove portarti",
      dKick:"Da mostrare al tassista",dTitle:"Mostra al<br>tassista",dSub:"Gira lo schermo verso il tassista",
      lbl:"Indirizzo di destinazione",phraseT:"",maps:"Apri in Maps",back:"Indietro",noAddr:"L'host non ha ancora inserito l'indirizzo.",bubble:"Devi tornare a casa? Usami, ti aiuto io tutta la notte"},
  de:{dot:"Nach Hause",kicker:"Dein Pass",title:"Torna<br>a casa",sub:"Ein Tipp und du bist zu Hause. Ruf ein Taxi und zeig diesen Pass dem Fahrer.",
      from:"Von",to:"Nach",now:"Jetzt",s1:"Taxi rufen",trusted:"Empfohlen von deinem Gastgeber",call:"Anrufen",apps:"Oder nutze eine App",open:"Öffnen",
      dest:"Ziel bereits eingestellt",metro:"Nachtverkehr",first:"Erste",last:"Letzte",walk:"Min. zu Fuß",
      cta:"Taxi kommt gleich? Hier tippen",ctaSub:"Zeig dem Fahrer, wohin es geht",
      dKick:"Für den Fahrer",dTitle:"Mostra al<br>tassista",dSub:"Dreh den Bildschirm zum Fahrer",
      lbl:"Zieladresse",phraseT:"Bitte bringen Sie mich zu dieser Adresse.",maps:"In Maps öffnen",back:"Zurück",noAddr:"Dein Gastgeber hat die Adresse noch nicht eingetragen.",bubble:"Musst du nach Hause? Nutz mich, ich helfe dir die ganze Nacht"},
  fr:{dot:"Rentrer chez moi",kicker:"Votre pass",title:"Torna<br>a casa",sub:"Un geste et vous êtes chez vous. Appelez un taxi, puis montrez ce pass au chauffeur.",
      from:"De",to:"À",now:"Maintenant",s1:"Appelez votre taxi",trusted:"Recommandé par votre hôte",call:"Appeler",apps:"Ou utilisez une app",open:"Ouvrir",
      dest:"Destination déjà définie",metro:"Transport de nuit",first:"Première",last:"Dernière",walk:"min à pied",
      cta:"Le taxi arrive ? Appuyez ici",ctaSub:"Montrez au chauffeur où vous emmener",
      dKick:"À montrer au chauffeur",dTitle:"Mostra al<br>tassista",dSub:"Tournez l'écran vers le chauffeur",
      lbl:"Adresse de destination",phraseT:"Bonsoir, emmenez-moi à cette adresse, s'il vous plaît.",maps:"Ouvrir dans Maps",back:"Retour",noAddr:"Votre hôte n'a pas encore ajouté l'adresse.",bubble:"Besoin de rentrer ? Utilise-moi, je t'aide toute la nuit"},
  es:{dot:"Volver a casa",kicker:"Tu pase",title:"Torna<br>a casa",sub:"Un toque y estás en casa. Llama un taxi y muestra este pase al conductor.",
      from:"Desde",to:"A",now:"Ahora",s1:"Llama a tu taxi",trusted:"De confianza de tu anfitrión",call:"Llamar",apps:"O usa una app",open:"Abrir",
      dest:"Destino ya configurado",metro:"Transporte nocturno",first:"Primera",last:"Última",walk:"min a pie",
      cta:"¿El taxi está llegando? Pulsa aquí",ctaSub:"Muestra al conductor a dónde llevarte",
      dKick:"Para mostrar al conductor",dTitle:"Mostra al<br>tassista",dSub:"Gira la pantalla hacia el conductor",
      lbl:"Dirección de destino",phraseT:"Buenas noches, lléveme a esta dirección, por favor.",maps:"Abrir en Maps",back:"Atrás",noAddr:"Tu anfitrión aún no ha añadido la dirección.",bubble:"¿Tienes que volver a casa? Úsame, te ayudo toda la noche"},
};

const APPS = {
  appIttaxi:{name:"itTaxi",desc:"Radio taxi italiani",logo:"/taxi-icons/ittaxi.jpg",
    ios:"https://apps.apple.com/app/id527559443",android:"https://play.google.com/store/apps/details?id=it.ud.microtek.ITTaxi"},
  appFreenow:{name:"FREENOW",desc:"Taxi app",logo:"/taxi-icons/freenow.webp",
    ios:"https://apps.apple.com/app/id357852748",android:"https://play.google.com/store/apps/details?id=taxi.android.client"},
  appUber:{name:"Uber",desc:"Luxury transport",logo:"/taxi-icons/uber.png",
    ios:"https://apps.apple.com/app/id368677368",android:"https://play.google.com/store/apps/details?id=com.ubercab"},
  appWetaxi:{name:"WeTaxi",desc:"All-in-one mobility",logo:"/taxi-icons/wetaxi.png",
    ios:"https://apps.apple.com/app/id1011103009",android:"https://play.google.com/store/apps/details?id=it.moveplus.easymoove.user"},
  appIntaxi:{name:"InTaxi",desc:"Il tuo taxi",logo:"/taxi-icons/intaxi.webp",
    ios:"https://apps.apple.com/gb/app/intaxi-il-tuo-taxi/id1258614882",android:"https://play.google.com/store/apps/details?id=it.ud.microtek.InTaxi&pcampaignid=web_share"},
};

const romeHour = () => {
  try {
    const s = new Intl.DateTimeFormat("en-GB",{timeZone:"Europe/Rome",hour:"2-digit",hour12:false}).format(new Date());
    return parseInt(s,10) % 24;
  } catch { return new Date().getHours(); }
};

const AppleIcon = () => (
  <svg viewBox="0 0 384 512" width="13" height="13" fill="currentColor" aria-hidden="true">
    <path d="M318.7 268c-.3-36 16.3-63 50-83-18.8-27-47.3-42-84.9-45-35.6-2.8-74.5 20.8-88.7 20.8-15 0-49.4-19.8-76.4-19.8C69.2 141.2 8 184.6 8 273c0 26.2 4.8 53.3 14.4 81.2 12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.8zM255.3 84.4c30.6-36.3 27.8-69.4 26.9-81.4-26.9 1.6-58 18.4-75.7 39.1-19.5 22.2-31 49.6-28.5 78.5 29.1 2.2 55.6-12.7 77.3-36.2z"/>
  </svg>
);
const AndroidIcon = () => (
  <svg viewBox="0 0 576 512" width="14" height="14" fill="currentColor" aria-hidden="true">
    <path d="M420.6 301.9a24 24 0 1 1 24-24 24 24 0 0 1-24 24m-265.1 0a24 24 0 1 1 24-24 24 24 0 0 1-24 24m273.7-144.5 47.9-83a10 10 0 1 0-17.3-10l-48.5 84.1a301.3 301.3 0 0 0-246.6 0L69.6 64.5a10 10 0 1 0-17.3 10l47.9 83C18.6 202.2 0 285.6 0 384h576c0-98.4-18.6-181.8-146.9-226.6"/>
  </svg>
);

function Ticket({ S, lang, step, onClose, goStep }){
  const t = T[lang] || T.en;
  if(step === 2){
    const geoFields = S.lat && S.lng;
    let lat = parseFloat(S.lat), lng = parseFloat(S.lng);
    // Se mancano le coordinate ma c'è un link Google Maps, prova a estrarle dal link.
    if ((!geoFields) && S.mapsUrl) {
      const u = S.mapsUrl;
      const m = u.match(/@(-?\d+\.\d+),(-?\d+\.\d+)/)
        || u.match(/[?&](?:q|ll|sll|daddr)=(-?\d+\.\d+),(-?\d+\.\d+)/)
        || u.match(/!3d(-?\d+\.\d+)!4d(-?\d+\.\d+)/)
        || u.match(/\/(-?\d+\.\d+),(-?\d+\.\d+)/);
      if (m) { lat = parseFloat(m[1]); lng = parseFloat(m[2]); }
    }
    const hasGeo = Number.isFinite(lat) && Number.isFinite(lng);
    const d = .004;
    const osmSrc = hasGeo ? `https://www.openstreetmap.org/export/embed.html?bbox=${lng-d},${lat-d/1.6},${lng+d},${lat+d/1.6}&layer=mapnik` : "";
    // Fallback: nessuna coordinata ma link/indirizzo → embed Google Maps con query.
    let gq = "";
    if (S.mapsUrl) {
      const pm = S.mapsUrl.match(/place\/([^/@]+)/);
      const qm = S.mapsUrl.match(/[?&]q=([^&]+)/);
      if (pm) gq = decodeURIComponent(pm[1].replace(/\+/g, " "));
      else if (qm && !/^-?\d+\.\d+,-?\d+\.\d+$/.test(decodeURIComponent(qm[1]))) gq = decodeURIComponent(qm[1]);
    }
    if (!gq) gq = ((S.street || "") + " " + (S.city || "")).trim();
    const gEmbed = gq ? `https://maps.google.com/maps?q=${encodeURIComponent(gq)}&z=15&output=embed` : "";
    const mapSrc = hasGeo ? osmSrc : gEmbed;
    const showMap = hasGeo || !!gEmbed;
    const gmaps = S.mapsUrl ? S.mapsUrl : (hasGeo ? `https://www.google.com/maps/search/?api=1&query=${lat},${lng}` : `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(gq)}`);
    return (
      <div className="ticket">
        <div className="checker" />
        <div className="driver-head">
          {onClose && <button className="t-close" style={{background:"rgba(255,255,255,.15)",color:"#fff"}} onClick={onClose}>✕</button>}
          <div className="t-kicker" style={{color:"#fff"}}>👀 {t.dKick}</div>
          <div className="t-title" dangerouslySetInnerHTML={{__html:t.dTitle}} />
          <div className="t-sub">{t.dSub}</div>
        </div>
        {S.street ? (
          <>
            <div className="addr">
              <div className="lbl">{t.lbl}</div>
              <div className="street">{S.street}</div>
              <div className="city">{S.city}</div>
              {S.note && <div className="note">🚪 {S.note}</div>}
            </div>
            <div className="phrase">🇮🇹 Buonasera, mi porti a questo indirizzo, per favore.{t.phraseT && <small>{t.phraseT}</small>}</div>
            {showMap && <div className="map"><iframe title="map" src={mapSrc} loading="lazy" /><div className="pin" /></div>}
            <div className="map-btns">
              <button className="btn-light" onClick={()=>goStep(1)}>← {t.back}</button>
              <a className="btn-dark" href={gmaps} target="_blank" rel="noopener noreferrer">🗺 {t.maps}</a>
            </div>
          </>
        ) : (
          <div style={{padding:"20px"}}><div className="empty">{t.noAddr}</div></div>
        )}
        <div style={{height:"20px"}} />
      </div>
    );
  }

  const trusted = [[S.trust1Name,S.trust1Phone],[S.trust2Name,S.trust2Phone]].filter(x=>x[1]);
  const apps = Object.keys(APPS).filter(k=>S[k]);
  const metro = S.metroStop && (S.metroFirst||S.metroLast);
  return (
    <div className="ticket">
      <div className="checker" />
      <div className="t-head">
        {onClose && <button className="t-close" onClick={onClose}>✕</button>}
        <div className="t-kicker">🚕 {t.kicker}</div>
        <div className="t-title" dangerouslySetInnerHTML={{__html:t.title}} />
        <div className="t-sub">{t.sub}</div>
      </div>
      <div className="perf"><span /></div>
      <div className="t-body">
        {trusted.length > 0 && (
          <>
            <div className="step-label"><i>1</i>{t.s1}</div>
            {trusted.map(([n,p],i)=>(
              <a key={i} className="call" href={`tel:${String(p).replace(/\s/g,"")}`}>
                <div className="ic">📞</div>
                <div className="tx"><small>{t.trusted}</small><strong>{n}</strong><span>{p}</span></div>
                <div className="go">{t.call}</div>
              </a>
            ))}
          </>
        )}

        <button className="cta" onClick={()=>goStep(2)}>🚖 {t.cta}<small>{t.ctaSub}</small></button>

        {apps.length > 0 && (
          <>
            <div className="step-label"><i>{trusted.length?"2":"1"}</i>{t.apps}</div>
            <div className="apps">
              {apps.map(k=>{
                const a = APPS[k];
                return (
                  <div className="app" key={k}>
                    <div className="app-row">
                      <img className="logo" src={a.logo} alt={a.name} loading="lazy" />
                      <div className="nm"><strong>{a.name}</strong><span>{a.desc}</span></div>
                    </div>
                    <div className="stores">
                      <a className="store store-ios" href={a.ios} target="_blank" rel="noopener noreferrer"><AppleIcon /> App Store</a>
                      <a className="store store-android" href={a.android} target="_blank" rel="noopener noreferrer"><AndroidIcon /> Google Play</a>
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        )}

        {metro && (
          <>
            <div className="step-label"><i>🚇</i>{t.metro}</div>
            <div className="metro">
              <div className="m">M</div>
              <div><strong>{S.metroStop}</strong><span>{S.metroWalk?`${S.metroWalk} ${t.walk}`:""}</span></div>
              <div className="times">
                {S.metroFirst && <><small>{t.first}</small>{S.metroFirst}</>}
                {S.metroLast && <><small style={{marginTop:"4px"}}>{t.last}</small>{S.metroLast}</>}
              </div>
            </div>
          </>
        )}

      </div>
    </div>
  );
}

/* Anteprima admin: ticket sempre visibile in un mini-telefono, aggiornato live */
export function TornaACasaPreview({ data, lang = "it" }){
  const S = data || {};
  const [step, setStep] = useState(1);
  const l = T[lang] ? lang : "en";
  return (
    <div className="tac-preview">
      <div className="tac-inner">
        <div className="tac">
          <Ticket S={S} lang={l} step={step} goStep={setStep} />
        </div>
      </div>
    </div>
  );
}

/* Guest: pallino sopra SOS + pass a schermo intero */
export default function TornaACasa({ data, lang = "it", preview = false }){
  const S = data || {};
  const [open, setOpen] = useState(false);
  const [step, setStep] = useState(1);
  const [night, setNight] = useState(() => { if (preview) return true; const h = romeHour(); return h >= 21 || h < 7; });
  const [bubble, setBubble] = useState(false);
  const l = T[lang] ? lang : "en";

  const hasContent = !!(S.trust1Phone || S.trust2Phone || S.appIttaxi || S.appFreenow || S.appUber || S.appWetaxi || S.street || S.metroStop);

  useEffect(() => {
    if (preview) { setNight(true); return; }
    const check = () => { const h = romeHour(); setNight(h >= 21 || h < 7); };
    check();
    const id = setInterval(check, 60000);
    return () => clearInterval(id);
  }, [preview]);

  // Anteprima admin: apri il biglietto se ci sono dati, altrimenti mostra il pallino che pulsa
  useEffect(() => {
    if (preview && hasContent) { setStep(1); setOpen(true); }
    else if (preview) { setOpen(false); }
  }, [preview, hasContent]);

  useEffect(() => {
    if (!night || preview) { if (!preview) setBubble(false); return; }
    const t1 = setTimeout(() => setBubble(true), 3000);
    return () => clearTimeout(t1);
  }, [night, preview]);

  useEffect(() => {
    if (!bubble) return;
    const t2 = setTimeout(() => setBubble(false), 5000);
    return () => clearTimeout(t2);
  }, [bubble]);

  const openPass = useCallback(() => { setBubble(false); setStep(1); setOpen(true); }, []);
  const close = useCallback(() => setOpen(false), []);

  return (
    <>
      <button
        className={`tac-dot ${night ? "night" : ""}`}
        onClick={openPass}
        aria-label={(T[l]||T.en).dot}
        data-testid="taxi-dot"
      >
        🚕<span className="tac-sr">{(T[l]||T.en).dot}</span>
      </button>

      {night && bubble && !open && (
        <div className="tac-bubble" data-testid="taxi-bubble" role="status">
          <button className="tac-bubble-x" onClick={() => setBubble(false)} aria-label="Chiudi" data-testid="taxi-bubble-close">✕</button>
          <span>{(T[l]||T.en).bubble}</span>
        </div>
      )}

      <div
        className={`tac-layer ${open ? "open" : ""}`}
        onClick={(e) => { if (e.target === e.currentTarget) close(); }}
        data-testid="torna-a-casa-layer"
      >
        <div className="tac-scroll" onClick={(e) => { if (e.target === e.currentTarget) close(); }}>
          <div className="tac">
            {open && <Ticket S={S} lang={l} step={step} onClose={close} goStep={(s)=>setStep(s)} />}
          </div>
        </div>
      </div>
    </>
  );
}
